// test124
(124 && 0);
